/**
 * The initial value of Symbol.replace is the well-known symbol @@replace
 * https://tc39.es/ecma262/#sec-symbol.replace
 */
export const symbolReplace = () => Symbol("Symbol.replace");
